import moment from 'moment';
import { IUserActivityLogRow } from 'src/SharedCustomHooks/UseReportingAPI/apiContracts';

export type IUserActivityMappedRow = IUserActivityLogRow;

const USER_ACTIVITY_DATE_FORMAT: string = 'dddd MM/DD/YYYY';
const USER_ACTIVITY_TIME_FORMAT: string = 'hh:mm A';

/* The API returns a single ISO `date` field per row. The table renders date
 * and time in separate columns, so we derive a `time` field and overwrite
 * `date` with a human-readable weekday form. */
export const mapUserActivityRow = (
  row: IUserActivityLogRow
): IUserActivityMappedRow => {
  const rowMoment: moment.Moment = moment(row.date);

  const formattedDate: string = rowMoment.format(USER_ACTIVITY_DATE_FORMAT);
  const formattedTime: string = rowMoment.format(USER_ACTIVITY_TIME_FORMAT);

  return {
    ...row,
    date: formattedDate,
    time: formattedTime,
  };
};
